import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Supplier.css';
import ConformModal from '../../../actions/ConformModal'; 

function SupplierNavbar({ supplier, setSupplier, toggleSidebar }) {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false); // state for modal

  const handleLogoutConfirm = () => {
    sessionStorage.removeItem('supplierInfo');
    setSupplier && setSupplier(null); // add safety check
    navigate('/login');
  };

  const handleLogoutClick = () => {
    setShowModal(true); // show the modal
  };

  const handleLoginRedirect = () => {
    navigate('/login?redirect=/SupplierDashboard');
  };

  const handleBrandClick = () => {
    const businessType = sessionStorage.getItem("businessType");
    if (businessType === "Engineering") {
      navigate("/engineering-home");
    } else if (businessType === "Building") {
      navigate("/others-home");
    } else {
      navigate("/");
    }
  };

  return (
    <>
      <nav className="navbar glass-navbar border-bottom">
        <div className="container-fluid">
          <span
            className="navbar-brand enhanced-brand"
            onClick={handleBrandClick}
            style={{ cursor: 'pointer' }}
          >
            AsiaSpare
          </span>

          <button className="btn btn-outline-secondary me-3" onClick={toggleSidebar}>
            <i className="bi bi-list"></i>
          </button>

          <div className="ms-auto d-flex align-items-center gap-3">
            {supplier ? (
              <>
                <span className="user-welcome">Welcome, {supplier.username}</span>
                <button className="logout-btn" onClick={handleLogoutClick}>Logout</button>
              </>
            ) : (
              <button className="nav-btn-enhanced" onClick={handleLoginRedirect}>Login</button>
            )}
          </div>
        </div>
      </nav>

      {/* Logout Confirmation Modal */}
      <ConformModal
        isOpen={showModal}
        message="Are you sure you want to logout from supplier?"
        onConfirm={() => {
          setShowModal(false);
          handleLogoutConfirm();
        }}
        onCancel={() => setShowModal(false)}
      />
    </>
  );
}

export default SupplierNavbar;
